import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';



const firebaseConfig = {
  apiKey: "AIzaSyB4lQm5TzdfPFFba7wqMwe4xhT29n80f6k",
  authDomain: "twitter-b76a9.firebaseapp.com",
  projectId: "twitter-b76a9",
  storageBucket: "twitter-b76a9.appspot.com",
  messagingSenderId: "216935967092",
  appId: "1:216935967092:web:45e93b77b531b9c5ee6421",
  measurementId: "G-1T6PVP7Y3T"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();


export default db;